/**
 * Definition list for label/value rows in chat. Vertical = two-column grid;
 * horizontal = wrapped label: value pairs.
 */
import { cn } from "@/lib/utils";

export interface DataListItem {
  label: string;
  value: string;
}

export interface DataListProps {
  items?: DataListItem[] | null;
  /** `vertical` (default): grid label | value. `horizontal`: inline pairs that wrap. */
  orientation?: "vertical" | "horizontal" | null;
}

const DataList = ({ items, orientation = null }: DataListProps) => {
  const horizontal = orientation === "horizontal";
  const rows = Array.isArray(items) ? items : [];

  return (
    <dl
      className={cn(
        horizontal
          ? "flex flex-wrap gap-x-6 gap-y-2"
          : "grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5",
      )}
    >
      {rows.map((item, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: order is fixed per spec render
          key={i}
          className={horizontal ? "flex items-center gap-1.5" : "contents"}
        >
          <dt className="text-xs text-muted-foreground">{item.label}</dt>
          <dd className="text-xs font-medium text-foreground">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default DataList;
